<template>
  <button :class="isPrimary ? 'button--primary' : 'button'" :disabled="!isActive" :style="buttonWidthStyle" @click="emitEvent()" outlined>{{ text }}</button>
</template>

<script>
export default {
  props: {
    // 表示するテキスト
    text: {
      type: String,
      required: true
    },
    // ボタンが活性状態かどうか（デフォルトはtrue）
    isActive: {
      type: Boolean,
      required: false,
      default: true
    },
    // 推奨の選択肢であるか（デフォルトはtrue）
    isPrimary: {
      type: Boolean,
      required: false,
      default: true
    },
    // ボタンのwidth
    buttonWidth: {
      type: String,
      required: false
    }
  },
  computed: {
    /**
     * @return {Object} ボタンのwidthのスタイル
     */
    buttonWidthStyle () {
      return {
        '--buttonWidth': this.buttonWidth
      }
    }
  },
  methods: {
    /**
     * 指定された処理を実行する
     */
    emitEvent () {
      this.$emit('emit-event')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.button {
  --buttonWidth: #{$unit_size*35};
  width: 100%;
  max-width: var(--buttonWidth);
  height: 52px;
  font-size: 1.5rem;
  font-weight: bold;
  background-color: $white_normal_color;
  border: 2px solid $black_normal_color;
  border-radius: 50px;
  box-shadow: 0 $unit_size $sand_pale_color;
  &:disabled {
    color: rgba($black_normal_color, 0.2) !important;
    box-shadow: 0 $unit_size rgba($red_normal_color, 0.5);
  }
  &--primary {
    @extend .button;
    box-shadow: 0 $unit_size $red_normal_color;
  }
}
</style>
